import { flowUtils } from '@atlassian/mpac-utils';
import { Either } from 'funfix-core';
import { Record } from 'immutable';
import { foldLicenseType } from '../spi/LicenseType';
import { makeEvaluationLicenseType, makeSubscriptionLicenseType } from './LicenseType';
export const makeFreePaymentModel = Record({
  type: 'free'
});
export const makePaidPaymentModel = Record({
  type: 'paid',
  licenseType: Either.left(makeEvaluationLicenseType())
});
export const makePaidPaymentModelFromSPI = a => makePaidPaymentModel({
  type: 'paid',
  licenseType: foldLicenseType(a.licenseType)(e => Either.left(makeEvaluationLicenseType(e)), s => Either.right(makeSubscriptionLicenseType(s)))
});
export const makePaymentModelFromSPIPaymentModel = a => {
  switch (a.type) {
    case 'free':
      return Either.left(makeFreePaymentModel(a));
    case 'paid':
      return Either.right(makePaidPaymentModelFromSPI(a));
    default:
      throw flowUtils.unexpectedCase(a);
  }
};